import { environment } from '@/environments/environment';
import { Component } from '@angular/core';

import { KerepLogoComponent } from '@shared/components/kerep-logo/kerep-logo.component';
import { KEREP_PRODUCT } from '@shared/constants/brand.constants';

/**
 * Pie de la aplicación: firma de marca, versión y autoría en una sola línea.
 *
 * El logotipo del tenant encabeza el sidebar, así que aquí firma Kerep — es la
 * capa de marca, no compite con la identidad de la empresa. Ver
 * `docs/modules/BRAND_GUIDE.md`.
 */
@Component({
  standalone: true,
  selector: 'app-footer',
  imports: [KerepLogoComponent],
  template: `
    <div class="layout-footer mt-5 flex-wrap gap-x-3 gap-y-1 text-xs">
      <span class="font-kerep flex items-center text-[var(--kerep-brand)]">
        <shared-kerep-logo variant="lockup" [product]="brandProduct" [size]="26" />
      </span>

      <span class="text-muted-color" aria-hidden="true">·</span>
      <span class="text-muted-color">v{{ version }}</span>

      <span class="text-muted-color" aria-hidden="true">·</span>
      <span class="text-muted-color">
        por
        <a
          href="https://conttrole.cl"
          target="_blank"
          rel="noopener noreferrer"
          class="font-semibold hover:text-primary hover:underline transition-colors"
          >Conttrole</a
        >
      </span>
    </div>
  `,
})
export class AppFooterComponent {
  protected get brandProduct(): string {
    return KEREP_PRODUCT;
  }

  version = environment.version;
}
